module.exports = __webpack_public_path__ + "static/media/linkedin.9419e9f0.svg";